import { Stack, Typography } from '@mui/material'
import rescheduleAnimation from 'components/Appointment/assets/lottie/success.json'
import cancelAnimation from 'components/Appointment/assets/lottie/cancel.json'
import Lottie from 'lottie-react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

export function EditAppointmentSuccess() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const isCancelAction = searchParams.get('action') === 'cancel'

  return (
    <Stack>
      <Lottie animationData={isCancelAction ? cancelAnimation : rescheduleAnimation} loop={false} style={{ height: '16rem' }} />
      <Typography variant="h1" textAlign="center">
        {t(isCancelAction ? 'pages.appointment.cancel.success' : 'pages.appointment.reschedule.success.message')}
      </Typography>
    </Stack>
  )
}
